<script setup lang="ts">
interface Props {
  caption: string;
  kind: 'card' | 'voucher';
  testId: string;
  title: string;
}

defineProps<Props>();

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const emit = defineEmits<{
  select: [];
}>();
</script>

<template>
  <a
    class="PaymentType__options-item kiosk-button"
    :data-testid="testId"
    href="#"
    @click.prevent="emit('select')"
  >
    <i
      class="PaymentType__options-icon"
      :class="`PaymentType__options-icon--${kind}`"
    />
    <div class="PaymentType__options-title">{{ title }}</div>
    {{ caption }}
  </a>
</template>

<style scoped lang="scss">
.PaymentType__options-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: 15rem;
  height: var(--kiosk-choice-card-height, 15rem);
  padding: var(--kiosk-choice-card-padding, 0 2rem);
  white-space: normal;
  text-align: center;
  margin-right: 3rem;
  font-size: var(--kiosk-choice-card-font-size, 1rem);

  &:last-child {
    margin-right: 0;
  }
}

.PaymentType__options-icon {
  width: 4rem;
  height: 4rem;
  display: block;
  margin-bottom: 1rem;
  background-color: var(--Kiosk--button_font_color);
  mask: {
    size: contain;
    position: center;
    repeat: no-repeat;
  };

  &--card {
    mask-image: url('../../../assets/images/payment-card.svg');
  }

  &--voucher {
    mask-image: url('../../../assets/images/payment-voucher.svg');
  }
}

.PaymentType__options-title {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}
</style>
